"use strict";

if (!customElements.get("toast-notification")) {
  customElements.define(
    "toast-notification",
    class ToastNotification extends HTMLElement {
      constructor() {
        super();

        this.messageEl = this.querySelector(".toast__message");
        // data-duration="0" disables auto-hide (toast stays until closed manually)
        const duration = parseInt(this.getAttribute("data-duration"), 10);
        this.duration = isNaN(duration) ? 5000 : duration;

        this.querySelector(".toast__close")?.addEventListener("click", () =>
          this.hide()
        );

        // Pause auto-hide while the user is reading (hover) or tabbed inside.
        this.addEventListener("mouseenter", () => this.pauseTimer());
        this.addEventListener("mouseleave", () => this.resumeTimer());
        this.addEventListener("focusin", () => this.pauseTimer());
        this.addEventListener("focusout", (event) => {
          if (!this.contains(event.relatedTarget)) this.resumeTimer();
        });
      }

      show(message) {
        if (message && this.messageEl) {
          this.messageEl.textContent = message;
        }

        // The progress bar animation reads this; without it the bar stays hidden.
        if (this.duration > 0) {
          this.style.setProperty("--toast-duration", this.duration + "ms");
        }
        this.classList.remove("toast--paused");

        // Double rAF so the browser paints the initial state first —
        // otherwise the open transition is skipped right after page load.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.setAttribute("open", ""));
        });

        if (this.duration > 0) {
          this.startTimer(this.duration);
        }
      }

      hide() {
        this.clearTimer();
        this.removeAttribute("open");
      }

      startTimer(ms) {
        this.clearTimer();
        this.remaining = ms;
        this.timerStart = Date.now();
        this.timer = setTimeout(() => this.hide(), ms);
      }

      pauseTimer() {
        if (!this.timer) return;
        this.remaining -= Date.now() - this.timerStart;
        clearTimeout(this.timer);
        this.timer = null;
        this.classList.add("toast--paused");
      }

      resumeTimer() {
        this.classList.remove("toast--paused");
        // remaining is only set once a timer has run — with auto-hide
        // disabled (duration 0) there is nothing to resume.
        if (!this.hasAttribute("open") || this.timer) return;
        if (typeof this.remaining !== "number") return;
        this.startTimer(Math.max(this.remaining, 0));
      }

      clearTimer() {
        if (this.timer) clearTimeout(this.timer);
        this.timer = null;
      }
    }
  );
}

window.showToast = function (message) {
  const toast = document.querySelector("toast-notification");
  toast?.show(message);
  return toast;
};
